/**
 *  Bug #473 
 * @Author Anupama P 
 * @Date 13 Jul 2021 
 * */
import PageNotFound from "client/components/page-not-found";
import { LoginContainers, LogoutMobiles, DoctorLogin, PageNotFoundPath, AppointmentsVirtualCheckIn, VirtualCheckIns, PaymentOtp, ApptUrls,AppReferences, UpdateAccessTokenMobiles, SSoMessaging, SSoMessages } from "config/routersConstants";

import React from "react";/* Bug #473 @Author Jithin Kuriakose @Date 01 July 2021 */
const SSOMessages = React.lazy(() => import("client/components/sso/messages"))//Bug #1072 @Author Anupama @date 12Oct2022
const DoctorMessages = React.lazy(() => import("client/components/messages"))/**Bug #1018 */



const LoginContainer = React.lazy(() => import("client/components/login/login"));

//blog

//pages
//const SearchDoctor = React.lazy(() => import("client/components/pages/searchdoctor"));
// const DoctorProfile = React.lazy(() => import("client/components/patients/doctorprofile"));
//const Checkout = React.lazy(() => import("client/components/patients/checkout"));
//pharmacy


// const PracticeProfile = React.lazy(() => import("client/components/practice/profile"));
/* End  */

/* End  */

const LogoutMobile = React.lazy(() => import("client/components/login/logoutMobile"));/*Bug #588 - Logout from Mobile App - Modified by Jithin Kuriakose on 03Sept2021*/

/* Bug #518  
* @Author Liya
* @Date 26 August 2021
*/

const VirtualCheckIn = React.lazy(() => import("client/components/virtual-check-in"));
const AppointmentVirtualCheckIn = React.lazy(() => import("client/components/virtual-check-in/appointments-virtual-checkin"));
const PaymentOtpPath = React.lazy(()=>import("client/components/patients/payment/otpverification"))
const ApptUrl = React.lazy(() => import("client/components/pages/appt-url"));/**Bug#808 @Author Aby @Date 22 Mar 2022*/
const AppReference = React.lazy(() => import("client/components/pages/app-reference"));
const UpdateAccessTokenMobile = React.lazy(() => import("client/components/login/updateAccessTokenMobile"));/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */


export const PublicRouting = [


  { component: LoginContainer, path: LoginContainers.path, label: LoginContainers.label, breadCrumb: [], layoutType: "public" },
  //{ component: Register, path: DoctorRegister.path, label: LoginContainers.label, breadCrumb: [], layoutType: "public" },
  //{ component: ForgotPassword, path: ForgotPasswords.path, label: LoginContainers.label, breadCrumb: [], layoutType: "public" },
  //{ component: Home, path: Homes.path, label: Homes.label, breadCrumb: [], layoutType: "public" },
  // { component: Home1 ,path:Home1s.path,label:Home1s.label, breadCrumb:[],layoutType:"public"},
  // { component: Home2 ,path:Home2s.path,label:Home2s.label, breadCrumb:[],layoutType:"public"},
  //{ component: SearchDoctor, path: SearchDoctors.path, label: SearchDoctors.label, breadCrumb: [], layoutType: "sidebarAndBreadCrumb" },
  //{ component: Booking, path: Bookings.path, label: Bookings.label, breadCrumb: { showBackArrow: 'true' }, layoutType: "sidebarAndBreadCrumb" },
  // { component: DoctorProfile ,path:DoctorProfiles.path,label:DoctorProfiles.label, breadCrumb:[],layoutType:"sidebarAndBreadCrumb"},
  // { component: PracticeProfile ,path:PracticeProfiles.path,label:PracticeProfiles.label, breadCrumb:[],layoutType:"sidebarAndBreadCrumb"},
  //{ component: ConfirmAccount, path: ConfirmAccounts.path, label: ConfirmAccounts.label, breadCrumb: [], layoutType: "public" },
  //{ component: ResetPassword, path: ResetPasswords.path, label: ResetPasswords.label, breadCrumb: [], layoutType: "public" },
  { component: LogoutMobile, path: LogoutMobiles.path, label: LogoutMobiles.label, breadCrumb: [], layoutType: "public" }, /*Bug #588 - Logout from Mobile App - Modified by Jithin Kuriakose on 03Sept2021*/
  //  { component: Checkout ,path:Checkouts.path, breadCrumb:[],layoutType:"public"},
  //     { path: "/login", component: LoginContainer ,layoutType:"public"},
  //     { path: "/register", component: Register,layoutType:"public" },
  //     { path: "/forgot-password", component: ForgotPassword ,layoutType:"public"},
  //     { path: "(/|/home)", component: Home ,layoutType:"public"},
  //     { path: "/home1", component: Home1,layoutType:"public" },
  //     { path: "/home2", component: Home2 ,layoutType:"public"},
  //     /**
  // * Bug #518 - remove unused routing path
  // * @Author Liya Baby
  // * @Date 26 July 2021
  // */
  //     //{ path: "/homeslider1", component: HomeSlider1 },
  //     //{ path: "/homeslider2", component: HomeSlider2 },
  //     { path: "/patient/search-doctor", component: SearchDoctor, breadCrumb:[{path:"/patient/search-doctor",label:"Search Doctor"}],layoutType:"sidebarAndBreadCrumb" },
  //     { path: "/patient/booking", component: Booking,breadCrumb:[{label:"Booking"}],layoutType:"breadCrumb" },
  //     { path: "/social-media", component: SocialMedia ,breadCrumb:[{label:"Social Media"}],layoutType:"doctor"},
  //     { path: "/patient/doctor-profile/:slug", component: DoctorProfile,breadCrumb:[{label:"Doctor Profile"}],layoutType:"doctor" },
  //     { path: "/practice/:slug", component: PracticeProfile ,breadCrumb:[{label:"Practice Profile"}],layoutType:"sidebarAndBreadCrumb"},

  //     { path: "/confirm-account/:token", component: ConfirmAccount ,layoutType:"public"},
  //     { path: "/reset-password/:token", component: ResetPassword,layoutType:"public" },
  //     { path: "/confirm-account/:token", component: ConfirmAccount },
  //     { path: "/reset-password/:token", component: ResetPassword },
  //     { path: "/patient/checkout", component: Checkout },

  { component: LoginContainer, path: DoctorLogin.path, label: DoctorLogin.label, breadCrumb: [], layoutType: "public" },
  //{ component: LoginContainer, path: PatientLogin.path, label: PatientLogin.label, breadCrumb: [], layoutType: "public" },
  { component: PageNotFound, path: PageNotFoundPath.path, label: PageNotFoundPath.label },
  //{ component: SearchProfile, path: SearchProfileInfo.path, label: SearchProfileInfo.label, breadCrumb: { showBackArrow: 'true' } },/** Bug#692 @Author: Linda Susan Raju @Date: 22 Feb 2022*/
  { component: VirtualCheckIn, path: VirtualCheckIns.path, label: VirtualCheckIns.label, breadCrumb: [] },
  { component: AppointmentVirtualCheckIn, path: AppointmentsVirtualCheckIn.path, label: AppointmentsVirtualCheckIn.label, breadCrumb: [] },/**Bug#576 @Author Linda Susan Raju @Date 27 Aug 2021*/
  { component: PaymentOtpPath, path: PaymentOtp.path, label: PaymentOtp.label, breadCrumb: [] },/**Bug#576 @Author Linda Susan Raju @Date 27 Aug 2021*/
  { component: ApptUrl, path: ApptUrls.path, label: ApptUrls.label, breadCrumb: [] },/**Bug#808 @Author Aby @Date 22 Mar 2022*/
  { component: AppReference , path: AppReferences.path, label: AppReferences.label, breadCrumb: [] },/**Bug#769  @Author Liya Baby @Date 08 March 2022*/

  { component: UpdateAccessTokenMobile, path: UpdateAccessTokenMobiles.path, label: UpdateAccessTokenMobiles.label, breadCrumb: [], layoutType: "public" },/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
  { component: SSOMessages, path: SSoMessaging.path, label: SSoMessaging.label },/** Bug #1018 midhila 17/08/2022 */
  { component: DoctorMessages, path: SSoMessages.path, label: SSoMessages.label },/** Bug #1018 midhila 17/08/2022 */

]